import store from "../../../store";

const authRoutes = [
  {
    path: "/auth",
    component: () => import(/* webpackChunkName: "auth-layout" */ "@/modules/auth/layouts/AuthLayout.vue"),
    children: [
      {
        path: "login",
        name: "auth.login",
        component: () => import(/* webpackChunkName: "auth-login-page" */ "@/modules/auth/pages/LoginPage.vue"),
      },
    ],
    beforeEnter(to, from, next) {
      const isLogged = store.getters["auth/isLogged"];

      if (isLogged) {
        next("/");
      } else {
        next();
      }
    },
  },
];

export default authRoutes;
